import type { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function emailDomainMatchingValidator<K1 extends string, K2 extends string>(
  emailControl: K1,
  domainControl: K2,
): ValidatorFn {
  return (group: FormGroup<{ [k in K1 | K2]: FormControl<string> }>) => {
    const emailValue = group.controls[emailControl].value;
    const domainValue = group.controls[domainControl].value;

    if (!emailValue || !domainValue) {
      return null;
    }

    const emailTrimmed = emailValue.split('@')[1];

    try {
      const url = new URL(domainValue);
      const domainTrimmed = url.hostname.replace(/^www\./, '');

      const isMismatch = emailTrimmed !== domainTrimmed;
      return isMismatch ? { domainEmailMismatch: true } : null;
    } catch (error) {
      return { domainEmailMismatch: true };
    }
  };
}
